import { Outlet, NavLink, useLocation } from 'react-router-dom'

const tabs = [
  { path: '/deals/part-ex/quote-requested', label: 'Quote Requested' },
  { path: '/deals/part-ex/quote-sent', label: 'Quote Sent' },
  { path: '/deals/part-ex/awaiting-collection', label: 'Awaiting Collection' },
  { path: '/deals/part-ex/shipping-arranged', label: 'Shipping Arranged' },
  { path: '/deals/part-ex/received', label: 'Received' },
  { path: '/deals/part-ex/accepted', label: 'Accepted' },
]

export default function PartExPage() {
  const location = useLocation()

  return (
    <div>
      <div className="pageTabs" style={{ marginTop: 8, fontSize: 13 }}>
        {tabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={location.pathname === tab.path ? 'active' : ''}
            style={{ whiteSpace: 'nowrap' }}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  )
}
